/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Requested_Documents_Other_PlaceholderInputs */

const en_task_requested_documents_other_placeholder = /** @type {(inputs: Task_Requested_Documents_Other_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the document being requested`)
};

const pt_br2_task_requested_documents_other_placeholder = /** @type {(inputs: Task_Requested_Documents_Other_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descreva o documento solicitado`)
};

/**
* | output |
* | --- |
* | "Describe the document being requested" |
*
* @param {Task_Requested_Documents_Other_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requested_documents_other_placeholder = /** @type {((inputs?: Task_Requested_Documents_Other_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requested_Documents_Other_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requested_documents_other_placeholder(inputs)
	return pt_br2_task_requested_documents_other_placeholder(inputs)
});